import React from 'react';
import { Modal, Button } from 'antd';
import { ExclamationCircleFilled } from '@ant-design/icons';
import './ActivatePaygModal.css';

interface ActivatePaygModalProps {
  isOpen: boolean;
  isLoading?: boolean;
  onCancel: () => void;
  onConfirm: () => void;
}

const ActivatePaygModal: React.FC<ActivatePaygModalProps> = ({
  isOpen,
  isLoading = false,
  onCancel,
  onConfirm,
}) => {
  return (
    <Modal
      open={isOpen}
      onCancel={onCancel}
      footer={null}
      centered
      width={612}
      className="activate-payg-modal"
      closable={false}
    >
      <div className="activate-payg-modal__content">
        <div className="activate-payg-modal__header">
          <ExclamationCircleFilled className="activate-payg-modal__icon" />
          <h3 className="activate-payg-modal__title">Activer le hors forfait ?</h3>
        </div>

        <p className="activate-payg-modal__description">
          Cet abonnement pourra continuer à utiliser Leedflow au-delà de son forfait.
        </p>

        <div className="activate-payg-modal__info-box">
          <h4 className="activate-payg-modal__info-title">Ce que ça change</h4>
          <ul className="activate-payg-modal__info-list">
            <li>Les appels et SMS restent disponibles une fois le forfait épuisé</li>
            <li>L'enregistrement, la transcription et l'analyse IA sont maintenus</li>
            <li>Des frais supplémentaires peuvent s'appliquer au-delà du forfait</li>
          </ul>
        </div>

        <div className="activate-payg-modal__actions">
          <Button className="activate-payg-modal__cancel-btn" onClick={onCancel}>
            Annuler
          </Button>
          <Button
            type="primary"
            className="activate-payg-modal__confirm-btn"
            onClick={onConfirm}
            loading={isLoading}
          >
            Activer le hors forfait
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export default ActivatePaygModal;
